export default "__VITE_ASSET__nHn7t6jU__"